/**
 * Vendor-side company (e.g. a BC Company under the connected tenant).
 * Returned by `GET /api/integrations/:connectionId/external-companies`.
 */
export interface IExternalCompany {
    id: string;
    name: string;
    displayName: string;
}
